import { Button } from 'antd'
import styled from 'styled-components'

const MenuBuilderSinceLookBanner = ({
  banner,
  canSeePlans = false,
  onShowRecipes,
  onShowStored,
  onSeePlans,
}) => {
  if (!banner?.show || !banner?.body) return null
  const showPlans = banner.nudgeAction === 'plans' && canSeePlans
  const showStored = banner.nudgeAction === 'stored'

  return (
    <Note role='status' data-testid='menu-builder-since-look'>
      <Title>{banner.title}</Title>
      <Body>{banner.body}</Body>
      {banner.nudge ? <Nudge>{banner.nudge}</Nudge> : null}
      <Actions>
        <Button size='small' onClick={onShowRecipes}>
          Show these recipes
        </Button>
        {showStored ? (
          <QuietButton type='button' onClick={onShowStored}>
            {banner.nudgeActionLabel || 'Show stored recipes'}
          </QuietButton>
        ) : null}
        {showPlans ? (
          <QuietButton type='button' onClick={onSeePlans}>
            {banner.nudgeActionLabel || 'See plans'}
          </QuietButton>
        ) : null}
      </Actions>
    </Note>
  )
}

const Note = styled.div`
  background: #f7f6f1;
  border: 1px solid #e6e4dc;
  border-radius: 8px;
  margin: 0 0 12px;
  padding: 12px 14px;
`

const Title = styled.div`
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
`

const Body = styled.div`
  color: rgba(0, 0, 0, 0.75);
  font-size: 13px;
  line-height: 18px;
`

const Nudge = styled.div`
  color: rgba(0, 0, 0, 0.55);
  font-size: 13px;
  line-height: 18px;
  margin-top: 4px;
`

const Actions = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`

const QuietButton = styled.button`
  background: transparent;
  border: 0;
  color: rgba(0, 0, 0, 0.55);
  cursor: pointer;
  font-size: 13px;
  padding: 0 4px;
  text-decoration: underline;
`

export default MenuBuilderSinceLookBanner
